import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    const pixelId = '1252242806993118';
    // Initialize fbq
    const w = window as any;
    if (w.fbq) return;
    const n: any = w.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // Load the FB pixel script by appending to head
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Fire events
    w.fbq('init', pixelId);
    w.fbq('track', 'PageView');
  }, []);
  return null;
}